import { render, staticRenderFns } from "./addproducttrans.vue?vue&type=template&id=65a79217&"
import script from "./addproducttrans.vue?vue&type=script&lang=js&"
export * from "./addproducttrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports